export default __webpack_public_path__ + "static/media/instagram.197b1824.svg";